import React, { Component } from "react";
import { Modal, Form, Col, Button, Row, Table, Container } from "react-bootstrap";
import "../HostelAttendance/_hostelattendance.scss"
import SelectDropDown from '../selectdropdown/SelectDropDown'
import { components } from 'react-select'
import CardLessDataTable from '../datatables/CardLessDataTableWithSearch';
import { graphql } from "react-apollo"
import moment from "moment";
import { gql } from "apollo-boost";
import * as Cookies from "es-cookie"
import { withRouter } from "react-router-dom";
import * as compose from "lodash.flowright";
import { withApollo } from "react-apollo";
import MultiSelect from "react-multi-select-component";
import SubmitHostelAttendanceModal from "./SubmitHostelAttendanceModal";


const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

class HostelAttendanceSection extends Component {
    constructor() {
        super();
        this.state = {
            branchSearchval: "",
            branchSearch: 0,
            branchError: "",

            buildingSearch: "",
            buildingError: "",
            buildingName: "",

            floorSearch: "",
            floorError: "",
            floorName: "",

            roomSearch: "",
            roomError: "",
            roomName: "",


            defaultvalue: 0,
            getBuildingDetails: [],
            getFloors: [],
            getRooms: [],

            roomOptions: [],
            selectedRooms: [],

            capacityDetails: [],
            date: new Date().toISOString().slice(0, 10),
            currentDate: new Date().toISOString().slice(0, 10),
            loading: 0,
            showtable: false,
            modalShow1: false,

            totalStudents: 0,
            presentStudents: 0,
            absentStudents: 0,

            search: "",
            currentPageStartCount: 0,
            currentPageEndCount: 10
        }
    }

    componentDidMount() {
        let branchData = [];
        if (Cookies.get("userlevel") == 8) {
            branchData = this.props.globals.globalBranches.filter((item) => item.id == Cookies.get("branch_id"))
        } else {
            branchData = this.props.globals.globalBranches
        }

        this.setState({
            branchSearchval: {
                value: branchData[0].id,
                label: branchData[0].branch_name
            },
            branchSearch: branchData[0].id
        })
        this.getBuildingCreationDetails(branchData[0].id)
    }

    dropDownGetValues(fieldname) {
        let getArray = [];
        if (fieldname == "branchSearch") {
            let branchData = [];
            if (Cookies.get("userlevel") == 8) {
                branchData = this.props.globals.globalBranches.filter((item) => item.id == Cookies.get("branch_id"))
            } else {
                branchData = this.props.globals.globalBranches
            }
            branchData.map((stumap) => {
                const newObj = {
                    value: stumap.id,
                    label: stumap.branch_name
                }
                getArray.push(newObj);
            });
        }
        return getArray;
    }


    selecthandleBranch = (name, value) => {
        console.log("call3");

        if (name == "branchSearch") {
            if (value != "0") {
                let branchSearchData = this.props.globals.globalBranches.find((a) => a.id == value);
                console.log("branchSearchData", branchSearchData);
                this.setState({
                    branchSearchval: {
                        value: branchSearchData.id,
                        label: branchSearchData.branch_name
                    },
                    branchSearch: branchSearchData.id,
                    buildingSearch: "",
                    buildingError: "",
                    floorSearch: "",
                    floorError: "",
                    roomSearch: "",
                    roomError: "",
                    getFloors: [],
                    getRooms: [],
                    roomOptions: [],
                    selectedRooms: [],
                    capacityDetails: [],
                    showtable: false,
                    totalStudents: 0,
                    presentStudents: 0,
                    absentStudents: 0,
                    search: "",
                })
                this.getBuildingCreationDetails(value);
            } else {
                this.setState({
                    branchSearchval: "",
                    branchSearch: 0,
                    buildingSearch: "",
                    buildingError: "",
                    floorSearch: "",
                    floorError: "",
                    roomSearch: "",
                    roomError: "",
                    getFloors: [],
                    getRooms: [],
                    capacityDetails: [],
                    showtable: false,
                    totalStudents: 0,
                    presentStudents: 0,
                    absentStudents: 0,
                    search: "",
                })
            }

        }
        this.setState({ [name]: value });
    }


    getBuildingCreationDetails = async (val) => {
        console.log("call2");
        let employeesData = [];


        const result1 = await this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int,){
                getEmployees(institute_id:$institute_id,branch_id:$branch_id){
                  employee_id
                  employee_name
                  employee_type_id
                }
              }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(val),
            },
            fetchPolicy: 'network-only'
        });

        if (result1.data.getEmployees.length > 0) {
            employeesData = result1.data.getEmployees
        }


        console.log("employeesData", employeesData);


        const result = await this.props.client.query({
            query: gql`
        query($institute_id: Int!, $branch_id: Int!, $fromDate: String!){
            getBuildingCreationDetails(institute_id: $institute_id, branch_id:$branch_id, fromDate: $fromDate ) {
                hostel_building_id
                hostel_building_name
                floors_details{
                  floor_id
                  floor_name
                  floor_incharge_id
                  rooms_details{
                    room_id
                    room_name
                    room_capacity
                    capacity_details{
                      edu_student_id
                      attendance_status
                    }
                  }
                }
            }
        }
        `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(val),
                fromDate: moment(this.state.date, 'YYYY-MM-DD').unix().toString()
            },
            fetchPolicy: 'network-only'
        })

        console.log("ttt", result.data.getBuildingCreationDetails);


        if (result.data.getBuildingCreationDetails.length > 0 && employeesData.length > 0) {
            let filter_data = result.data.getBuildingCreationDetails

            if (filter_data.length > 0) {
                let data = [];

                if (Cookies.get("userlevel") == 8) {
                    filter_data.map((item) => {
                        let floorData = [];
                        item.floors_details.map((item1) => {

                            if (item1.floor_incharge_id.includes(Cookies.get("id"))) {
                                floorData.push({ ...item1 })
                            }

                        })

                        if (floorData.length > 0) {
                            data.push({ ...item, floors_details: floorData })
                        }
                    })

                } else {
                    data = filter_data
                }

                console.log("data", data, employeesData);

                this.setState({
                    getBuildingDetails: data,
                    loading: 0
                })
            }
        }
        else {
            this.setState({
                getBuildingDetails: [],
                loading: 0
            })
        }

    }


    handleInputChange = (e) => {
        console.log("call1");
        let name = e.target.name
        let value = e.target.value
        if (name == "date") {
            this.setState({
                date: value,
                buildingSearch: "",
                buildingName: "",
                buildingError: "",
                floorSearch: "",
                floorError: "",
                roomSearch: "",
                roomError: "",
                getFloors: [],
                getRooms: [],
                roomOptions: [],
                selectedRooms: [],
                capacityDetails: [],
                showtable: false,
                totalStudents: 0,
                presentStudents: 0,
                absentStudents: 0,
                search: "",
            })
            setTimeout(() => {
                this.getBuildingCreationDetails(this.state.branchSearch);

            }, 100)
        }

        if (name == "buildingSearch") {
            let getFloors = []
            if (value != 0) {
                getFloors = this.state.getBuildingDetails.filter((a) => a.hostel_building_id == value)[0].floors_details
                const selectedBuilding = this.state.getBuildingDetails.find(a => a.hostel_building_id == value);

                this.setState({
                    buildingSearch: value,
                    buildingName: selectedBuilding.hostel_building_name,
                    buildingError: "",
                    floorSearch: "",
                    floorError: "",
                    roomSearch: "",
                    roomError: "",
                    getFloors: getFloors,
                    capacityDetails: [],
                    getRooms: [],
                    roomOptions: [],
                    selectedRooms: [],
                    showtable: false,
                    totalStudents: 0,
                    presentStudents: 0,
                    absentStudents: 0,
                    search: "",
                })
            } else {
                this.setState({
                    buildingSearch: "",
                    buildingName: "",
                    buildingError: "",
                    floorSearch: "",
                    floorError: "",
                    roomSearch: "",
                    roomError: "",
                    getFloors: [],
                    capacityDetails: [],
                    getRooms: [],
                    roomOptions: [],
                    selectedRooms: [],
                    showtable: false,
                    totalStudents: 0,
                    presentStudents: 0,
                    absentStudents: 0,
                    search: "",
                })
            }

        }

        if (name == "floorSearch") {

            console.log("floor");
            let getRooms = []
            if (value != 0) {
                getRooms = this.state.getFloors.filter((a) => a.floor_id == value)[0].rooms_details;

                console.log("getRooms", getRooms);
                const selectedFloor = this.state.getFloors.find(a => a.floor_id == value)

                let roomOptions = [];

                if (getRooms.length > 0) {
                    getRooms.map((item) => {
                        const newObj = {
                            value: item.room_id,
                            label: item.room_name
                        }
                        roomOptions.push(newObj)

                    })
                }
                this.setState({
                    floorSearch: value,
                    floorName: selectedFloor.floor_name,
                    floorError: "",
                    roomSearch: "",
                    roomName: "",
                    roomError: "",
                    getRooms: getRooms,
                    roomOptions: roomOptions.sort((a, b) => a.value - b.value),
                    selectedRooms: roomOptions.sort((a, b) => a.value - b.value),
                    capacityDetails: [],
                    showtable: false,
                    totalStudents: 0,
                    presentStudents: 0,
                    absentStudents: 0,
                    search: "",
                })
            } else {
                this.setState({
                    floorSearch: "",
                    floorName: "",
                    floorError: "",
                    roomSearch: "",
                    roomError: "",
                    roomName: "",
                    getRooms: [],
                    roomOptions: [],
                    selectedRooms: [],
                    capacityDetails: [],
                    showtable: false,
                    totalStudents: 0,
                    presentStudents: 0,
                    absentStudents: 0,
                    search: "",
                })
            }
        }
    }


    handleSubmit1 = (e) => {
        e.preventDefault();
        console.log("call14");



        if (this.state.buildingSearch == "") {
            this.setState({ buildingError: "Please select Building" })
            return ""
        }
        if (this.state.floorSearch == "") {
            this.setState({ floorError: "Please select Floor" })
            return ""
        }
        if (!this.state.selectedRooms.length) {
            this.setState({ roomError: "Please select Room" });
            return ""
        }

        console.log("rooms", this.state.selectedRooms);
        console.log("roomWiseData1", this.state.getRooms);



        this.setState({ loading: 1 })

        let studentsData = [];

        this.state.selectedRooms.map((item) => {
            let roomWiseData = this.state.getRooms.filter((item1) => item1.room_id == item.value);
            console.log("roomWiseData", roomWiseData, item, this.state.getRooms);
            if (roomWiseData[0].capacity_details.length > 0) {
                roomWiseData[0].capacity_details.map((item3) => {
                    studentsData.push({ ...item3, roomName: roomWiseData[0].room_name, roomSearch: roomWiseData[0].room_id })
                })
            }

        })

        let totalStudents = 0;
        let no_of_absent = 0;
        let no_of_present = 0;
        let students_attendance_data = [];

        if (studentsData.length > 0) {
            studentsData.map((item) => {
                let studentDetails = this.props.getNewEducationalStudents.filter((a) => a.student_id == item.edu_student_id)
                students_attendance_data.push({ ...item, ...studentDetails[0] })
            });
            console.log("studentsData", students_attendance_data);

            totalStudents = students_attendance_data.length;
            no_of_present = students_attendance_data.filter(student => student.attendance_status === 1).length;
            no_of_absent = students_attendance_data.filter(student => student.attendance_status === 0).length;
        }
        let students_attendance_sorted_data = students_attendance_data.sort((a, b) => {
            if (a.attendance_status < b.attendance_status) {
                return -1;
            } else if (a.attendance_status > b.attendance_status) {
                return 1;
            }
            if (a.roll_no < b.roll_no) {
                return -1;
            } else if (a.roll_no > b.roll_no) {
                return 1;
            }
            return 0;
        });

        this.setState({ capacityDetails: students_attendance_sorted_data, totalStudents: totalStudents, presentStudents: no_of_present, absentStudents: no_of_absent })

        setTimeout(() => {
            this.setState({ showtable: true, loading: 0 })
        }, 1000);


    }



    presentOrAbsent(e, row) {
        let studentAttendanceData = []

        studentAttendanceData = this.state.capacityDetails.map((item) => {
            if (item.edu_student_id == row.edu_student_id) {
                if (e.target.value == 1) {
                    return { ...item, attendance_status: 1 }
                } else if (e.target.value == 0) {
                    return { ...item, attendance_status: 0 }
                }
            } else {
                return { ...item }
            }
        });

        let totalStudents = this.state.capacityDetails.length;
        let no_of_present = studentAttendanceData.filter((item) => item.attendance_status == 1).length;
        let no_of_absent = studentAttendanceData.filter((item) => item.attendance_status == 0).length;
        this.setState({ capacityDetails: studentAttendanceData, totalStudents: totalStudents, presentStudents: no_of_present, absentStudents: no_of_absent })
    }

    searchFilter = (e) => {
        let value = e.target.value
        console.log("e", value);
        this.setState({ search: value, currentPageStartCount: 0, currentPageEndCount: 10 })
    }

    pageChange = (pageNumber) => {
        console.log("pageNumber", pageNumber);
        this.setState({
            currentPageStartCount: (+pageNumber - 1) * 10,
            currentPageEndCount: +pageNumber * 10
        })
    }

    handleMultipleSelectInputChange = (e, name) => {
        console.log("call6");

        if (name == "room") {

            console.log("room");

            let selectedRooms = []
            if (e.length > 0) {
                for (let i = 0; i < e.length; i++) {
                    const roomval = e[i];
                    const newObj = {
                        label: roomval.label,
                        value: roomval.value,
                    }
                    selectedRooms.push(newObj);
                }
                this.setState({
                    selectedRooms: selectedRooms,
                    roomName: selectedRooms[0].label,
                    capacityDetails: [],
                    roomError: "",
                    showtable: false,
                    totalStudents: 0,
                    presentStudents: 0,
                    absentStudents: 0,
                    search: "",
                })
            } else {
                this.setState({
                    selectedRooms: [],
                    roomName: "",
                    capacityDetails: [],
                    roomError: "",
                    showtable: false,
                    totalStudents: 0,
                    presentStudents: 0,
                    absentStudents: 0,
                    search: "",
                })
            }
        }
    }

    render() {
        console.log("prr1223", this.state,);

        let roomselectall = true;
        let roomlabelledBy = "Select";
        let roomdisableSearch = false;

        if (this.state.getRooms.length > 0) {
            roomselectall = true;
            roomdisableSearch = false;
        }
        else {
            roomdisableSearch = true;
            roomselectall = false;
            roomlabelledBy = "--Select--"
        }

        let filterStudentData = this.state.capacityDetails;
        console.log("filterStudentData", filterStudentData);

        if (this.state.search != "") {
            filterStudentData = this.state.capacityDetails.filter((item) => item.roll_no.includes(this.state.search) || item.student_name.toLowerCase().includes(this.state.search.toLowerCase()) || item.roomName.toLowerCase().includes(this.state.search.toLowerCase()))
        }


        let pages = Math.ceil(filterStudentData.length / 10);


        let pagewiseFilterData = filterStudentData.filter((item, index) => index >= this.state.currentPageStartCount && index < this.state.currentPageEndCount);

        console.log("pages", pagewiseFilterData);




        return (
            <section className="students_section">
                <Container fluid>
                    <Row className="mt-3">
                        <Col xl={12} lg={12} md={12} sm={12}>
                            <div className="breadcrumb_section border-bottom border-theme pb-1 mr-3 ml-3 d-flex align-items-center justify-content-between">
                                <h2 className="title h5 mb-0 ">HOSTEL ATTENDANCE</h2>
                                <div className="filter-block d-flex align-items-center mr-4">
                                    <input type="date" className="date_style" name="date" value={this.state.date} onChange={this.handleInputChange} max={this.state.currentDate} />
                                </div>
                            </div>
                        </Col>
                        <Col xl={12} lg={12} md={12} sm={12}>
                            <Row className="mt-5">
                                <Col lg={2} md={12} sm={12}>
                                    <Form.Group as={Col} >
                                        <Form.Label className='font-weight-bold fs-5'>Branch</Form.Label>
                                        <SelectDropDown
                                            stateData={this.state.branchSearchval}
                                            handleChange={this.selecthandleBranch}
                                            name="branchSearch"
                                            options={this.dropDownGetValues("branchSearch")}
                                            placeholderName={'Branch'}
                                            dropdownIndicator={{ DropdownIndicator }}
                                        />
                                        <Form.Text className="form-text text-danger">
                                            {this.state.branchError}
                                        </Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col lg={2} md={12} sm={12}>
                                    <Form.Group as={Col} >
                                        <Form.Label className='font-weight-bold fs-5'>Building Name</Form.Label>
                                        <Form.Control as="select" name="buildingSearch" onChange={this.handleInputChange} value={this.state.buildingSearch}>
                                            <option value={this.state.defaultvalue}>--Select--</option>
                                            {this.state.getBuildingDetails.map(buildname => (
                                                <option value={buildname.hostel_building_id}>{buildname.hostel_building_name}</option>
                                            ))}
                                        </Form.Control>
                                        <Form.Text className="form-text text-danger">
                                            {this.state.buildingError}
                                        </Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col lg={2} md={12} sm={12}>
                                    <Form.Group as={Col} >
                                        <Form.Label className='font-weight-bold fs-5'>Floor Name</Form.Label>
                                        <Form.Control as="select" name="floorSearch" onChange={this.handleInputChange} value={this.state.floorSearch}>
                                            <option value={this.state.defaultvalue}>--Select--</option>
                                            {this.state.getFloors.map(floor => (
                                                <option value={floor.floor_id}>{floor.floor_name}</option>
                                            ))}
                                        </Form.Control>
                                        <Form.Text className="form-text text-danger">
                                            {this.state.floorError}
                                        </Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col lg={2} md={12} sm={12}>
                                    <Form.Group as={Col} >
                                        <Form.Label className='font-weight-bold fs-5'>Room Name</Form.Label>
                                        <MultiSelect
                                            overrideStrings={{
                                                "allItemsAreSelected": "All Rooms are selected.",
                                                "selectSomeItems": roomlabelledBy
                                            }
                                            }
                                            disableSearch={roomdisableSearch}
                                            hasSelectAll={roomselectall}
                                            options={this.state.roomOptions}
                                            value={this.state.selectedRooms}
                                            onChange={(e) => this.handleMultipleSelectInputChange(e, "room")}
                                            labelledBy={"room"}
                                        />
                                        <Form.Text className="form-text text-danger">
                                            {this.state.roomError}
                                        </Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col lg={2} md={12} sm={12}>
                                    <Form.Group as={Col}>
                                        <Button className="btn  text-uppercase submit_btn" onClick={(e) => { this.handleSubmit1(e) }}>
                                            Get Students</Button>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={12}>
                                    <div className={this.state.loading == 1 ? "d-flex align-items-center spinner-border  text-center loading-img-center mt-5" : ""} style={{ color: "#213046" }}>
                                    </div>
                                </Col >
                            </Row>
                        </Col>
                    </Row>
                    {
                        this.state.showtable == true ?
                            (
                                <>

                                    {
                                        this.state.capacityDetails.length > 0 ? (
                                            <>
                                                <Row  >
                                                    <Col sm={12}>
                                                        <h6 className="text-center text-danger res_view">Note: By default all students are marked as present. Change to mark as absent</h6>
                                                    </Col>
                                                </Row>


                                                <Row>
                                                    <Col lg={3} md={3} sm={12} >
                                                        <Form.Group as={Col} controlId="formSearch">
                                                            <Form.Control type="text" placeholder="Search" name='search' onChange={(e) => this.searchFilter(e)} />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>


                                                <Row>
                                                    <Col sm={12}>
                                                        <div className="hostel_attendance_table">
                                                            <Table striped bordered hover className="text-center hostel_attendance_table">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Student Name</th>
                                                                        <th>Student Roll No</th>
                                                                        <th>Building Name</th>
                                                                        <th>Floor Name</th>
                                                                        <th>Room Name</th>
                                                                        <th>Attendance Status</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        pagewiseFilterData.map((item) => {

                                                                            let attendance_status = [{ value: 1, label: "Present" }, { value: 0, label: "Absent" }];


                                                                            return (
                                                                                <>
                                                                                    <tr>
                                                                                        <td>{item.student_name}</td>
                                                                                        <td>{item.roll_no}</td>
                                                                                        <td>{this.state.buildingName}</td>
                                                                                        <td>{this.state.floorName}</td>
                                                                                        <td>{item.roomName}</td>
                                                                                        <td>
                                                                                            <select className={item.attendance_status == "0" ? "selectWithColors" : "selectWithOutColors"} onChange={(e) => { this.presentOrAbsent(e, item) }} >
                                                                                                {
                                                                                                    attendance_status.map((item1) => {
                                                                                                        if (item1.value == item.attendance_status) {
                                                                                                            return <option value={item1.value} selected  >{item1.label}</option>
                                                                                                        } else {
                                                                                                            return <option value={item1.value}  >{item1.label}</option>
                                                                                                        }
                                                                                                    })
                                                                                                }
                                                                                            </select>
                                                                                        </td>
                                                                                    </tr>
                                                                                </>
                                                                            )
                                                                        })
                                                                    }
                                                                </tbody>

                                                            </Table>
                                                        </div>
                                                        <Row>
                                                            <Col className="d-flex justify-content-start mr-3 mb-3">
                                                                {
                                                                    Array.from({ length: pages }, (_, index) => {
                                                                        return (
                                                                            <p className={this.state.currentPageStartCount / 10 == index ? "ml-2 pageIndexs active" : "ml-1 pageIndex"} onClick={() => this.pageChange(index + 1)}>{index + 1}</p>
                                                                        )
                                                                    })
                                                                }
                                                            </Col>
                                                            <Col >
                                                                <div className="filter-block d-flex align-items-center justify-content-end mr-4">
                                                                    <Button variant="success" className="text-uppercase px-4 mb_50" onClick={() => this.setState({ modalShow1: true })}>submit attendance</Button>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Col>


                                                </Row>
                                            </>
                                        ) : (
                                            <Row>
                                                <Col sm={12}>
                                                    {
                                                        this.state.capacityDetails.length == 0 ? (
                                                            <h6 className="d-flex justify-content-center align-items-center mt-5">No students available</h6>
                                                        ) : ("")
                                                    }
                                                </Col >
                                            </Row>
                                        )

                                    }
                                </>
                            )
                            :
                            (
                                ""
                            )
                    }

                    <SubmitHostelAttendanceModal
                        show={this.state.modalShow1}
                        onHide={() => this.setState({ modalShow1: false })}
                        stateData={this.state}
                    />
                </Container>
            </section>
        )
    }
}

export default withRouter(withApollo(


    (HostelAttendanceSection))
);
